export const I18N_NAMESPACES = [
  'admin-engine',
  'auth',
  'bases',
  'business',
  'common',
  'contractors',
  'dashboard',
  'delegations',
  'dictionaries',
  'documents',
  'drivers',
  'employees',
  'engine-config',
  'fleet',
  'fuel-policy',
  'gantt',
  'import',
  'integrations',
  'map',
  'nav-submenu',
  'orders',
  'points-of-interest',
  'route-costs-and-preferences',
  'route',
  'settings',
] as const;
